export const bootCamp = 'Boot Camp';
export const executiveEducation = 'Executive Education';
export const course = 'Course';

export const control = 'control';
export const treatment = 'treatment';
export const noExperiment = 'no experiment';
